import { useLocation } from 'react-router-dom'

export default function SharePreview() {
  const location = useLocation()
  const preview = location.state?.preview 

  return (
    <div className="share-preview-page">
      <h1 className="share-preview-title">测评报告预览</h1>

      {preview ? (
        <img src={preview} alt="报告预览" className="share-preview-img" />
      ) : (
        <p>暂无预览图片</p>
      )}

      <div class="share-preview-tip">长按图片保存到相册</div>
    </div>
  )
}
